import React from "react";
import {
FaBible,
FaChalkboardTeacher,
FaGlobeAmericas,
FaUsers
} from "react-icons/fa";

export default function Academia() {
return (
<>
<section
className="text-white d-flex align-items-center"
style={{
minHeight: "70vh",
background:
"linear-gradient(rgba(0,0,0,.55), rgba(61,16,66,.75)), url('https://images.unsplash.com/photo-1522202176988-66273c2fd55f')",
backgroundSize: "cover",
backgroundPosition: "center",
marginTop: "100px"
}}
> <div className="container text-center"> <h1 className="display-3 fw-bold">
Academia Misionera </h1>

```
      <p className="lead">
        Formación bíblica, liderazgo y preparación para las misiones.
      </p>
    </div>
  </section>

  <section className="py-5">
    <div className="container">

      <div className="row text-center mb-5">
        <div className="col">
          <h2
            className="fw-bold"
            style={{ color: "#3d1042" }}
          >
            Nuestro Objetivo
          </h2>

          <p className="lead">
            Preparar jóvenes para servir a Dios con excelencia,
            carácter cristiano y visión misionera.
          </p>
        </div>
      </div>

      <div className="row g-4">

        <div className="col-md-3">
          <div className="card border-0 shadow h-100 text-center p-4">
            <FaBible size={50} color="#9b2a92" />
            <h5 className="mt-3">Biblia</h5>
            <p>Fundamentos sólidos de la fe cristiana.</p>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card border-0 shadow h-100 text-center p-4">
            <FaUsers size={50} color="#2e7d32" />
            <h5 className="mt-3">Liderazgo</h5>
            <p>Desarrollo de líderes para servir a otros.</p>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card border-0 shadow h-100 text-center p-4">
            <FaChalkboardTeacher size={50} color="#9b2a92" />
            <h5 className="mt-3">Capacitación</h5>
            <p>Herramientas prácticas para el ministerio.</p>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card border-0 shadow h-100 text-center p-4">
            <FaGlobeAmericas size={50} color="#2e7d32" />
            <h5 className="mt-3">Misiones</h5>
            <p>Visión global para alcanzar las naciones.</p>
          </div>
        </div>

      </div>

    </div>
  </section>
</>

);
}
